var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1882_854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F8153B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1882_854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 17.5L13.0834 16.25C12.9167 16.1806 12.7605 16.1077 12.6147 16.0313C12.4688 15.9549 12.3195 15.8612 12.1667 15.75L10.9584 16.125L10.1251 14.7084L11.0834 13.875C11.0556 13.6806 11.0417 13.5 11.0417 13.3334C11.0417 13.1667 11.0556 12.9862 11.0834 12.7917L10.1251 11.9584L10.9584 10.5417L12.1667 10.9167C12.3195 10.8056 12.4688 10.7118 12.6147 10.6355C12.7605 10.5591 12.9167 10.4862 13.0834 10.4167L13.3334 9.16671H15.0001L15.2501 10.4167C15.4167 10.4862 15.573 10.5625 15.7188 10.6459C15.8647 10.7292 16.014 10.8334 16.1667 10.9584L17.3751 10.5417L18.2084 12L17.2501 12.8334C17.2779 13 17.2917 13.1737 17.2917 13.3542C17.2917 13.5348 17.2779 13.7084 17.2501 13.875L18.2084 14.7084L17.3751 16.125L16.1667 15.75C16.014 15.8612 15.8647 15.9549 15.7188 16.0313C15.573 16.1077 15.4167 16.1806 15.2501 16.25L15.0001 17.5H13.3334ZM1.66675 16.6667V14.3334C1.66675 13.875 1.7848 13.4445 2.02091 13.0417C2.25703 12.6389 2.58341 12.3334 3.00008 12.125C3.70841 11.7639 4.50703 11.4584 5.39591 11.2084C6.2848 10.9584 7.26397 10.8334 8.33342 10.8334H8.62508C8.70842 10.8334 8.79175 10.8473 8.87508 10.875C8.4723 11.875 8.30564 12.8681 8.37508 13.8542C8.44453 14.8403 8.77786 15.7778 9.37508 16.6667H1.66675ZM14.1667 15C14.6251 15 15.0174 14.8368 15.3438 14.5105C15.6702 14.1841 15.8334 13.7917 15.8334 13.3334C15.8334 12.875 15.6702 12.4827 15.3438 12.1563C15.0174 11.8299 14.6251 11.6667 14.1667 11.6667C13.7084 11.6667 13.3161 11.8299 12.9897 12.1563C12.6633 12.4827 12.5001 12.875 12.5001 13.3334C12.5001 13.7917 12.6633 14.1841 12.9897 14.5105C13.3161 14.8368 13.7084 15 14.1667 15ZM8.33342 10C7.41675 10 6.63203 9.67365 5.97925 9.02087C5.32647 8.3681 5.00008 7.58337 5.00008 6.66671C5.00008 5.75004 5.32647 4.96532 5.97925 4.31254C6.63203 3.65976 7.41675 3.33337 8.33342 3.33337C9.25008 3.33337 10.0348 3.65976 10.6876 4.31254C11.3404 4.96532 11.6667 5.75004 11.6667 6.66671C11.6667 7.58337 11.3404 8.3681 10.6876 9.02087C10.0348 9.67365 9.25008 10 8.33342 10Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSettings);
export default __webpack_public_path__ + "static/media/profileSettings.e7318e4b299aee75c42f796b57a96a37.svg";
export { ForwardRef as ReactComponent };